import { injectGlobal } from 'styled-components';
import Logo from '../assets/images/logo-login.png';

injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700');

  * {
    margin: 0;
    padding: 0;
    outline: 0;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
  }

  body {
    background-color: #f1f4f5;
    font-family: Roboto, sans-serif;
    font-size: 14px;
  }

  a, .btn-link {
    color: #cc00b0;

    &:hover, &:active {
      color: #a90491;
    }
  }
  .btn-primary {
    background-color: #cc00b0;
    border-color: #cc00b0;

    &:hover,
    &:active {
      background-color: #a90491;
      border-color: #a90491;
    }
  }

  .btn-primary:not(:disabled):not(.disabled).active,
  .btn-primary:not(:disabled):not(.disabled):active,
  .show>.btn-primary.dropdown-toggle {
    background-color: #a90491;
    border-color: #a90491;
  }

  .btn-info {
    background-color: #bdbdbd;
    border-color: #bdbdbd;

    &:hover,
    &:active {
      background-color: #909090;
      border-color: #909090;
    }
  }

  .btn-info:not(:disabled):not(.disabled).active,
  .btn-info:not(:disabled):not(.disabled):active,
  .show>.btn-info.dropdown-toggle {
    background-color: #909090;
    border-color: #909090;
  }

  input[type='submit'] {
    cursor: pointer;
  }

  input[type=file]{
    max-width: 100%;
  }

  .btn, .dropdown-item {
    font-size: 14px;
  }

  .btn-add {
    padding: 10px 17px;
    font-size: 23px;
    border-radius: 50%;
    box-shadow: 0 6px 10px rgba(0,0,0,.15);
  }

  .btn-fixed {
    position: fixed;
    bottom: 50px;
    right: 40px;
  }

  .btn-light {
    background-color: #e0e0e0;
    border-color: #e0e0e0;

    &:hover {
      background-color: #cbced2;
      border-color: #c1c6ca;
    }
  }

  .page-title {
    color: #37474f;
    font-size: 26px;
    margin-bottom: 25px;

    &.inline {
      float: left;
    }
  }

  .section-title {
    margin-top: 25px;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .red-text {
    color: red;
    font-weight: bold;
  }

  .green-text {
    color: green;
    font-weight: bold;
  }

  .box {
    color: #5b5b5b;
    background-color: #fff;
    border: 0 solid transparent;
    border-radius: 4px;
    box-shadow: 0 1px 1px rgba(0,0,0,.05);
    padding: 35px 40px;

    .box-header {
      display: flex;
      margin-bottom: 20px;
    }

    @media (max-width: 600px) {
      padding: 15px 20px;
    }
  }

  .table-wrapper {
    overflow: scroll;
  }

  .cards-grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat( auto-fit, 290px );
    grid-gap: 20px;

    @media (max-width: 430px) {
      grid-template-columns: auto;
    }
  }

  .card {
    .card-image {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      height: 0;
      margin-bottom: 0;
      overflow: hidden;
      padding-bottom: 40%;
      position: relative;

      .card-label {
        width: 150px;
        background: #0077e6;
        color: #fff;
        text-transform: uppercase;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 12px;
        text-align: center;
        transform: rotate(45deg);
        position: absolute;
        right: -43px;
        top: 24px;
      }
    }

    .card-image.vertical{
      background-size: contain;

      @media (max-width: 991px) {
        padding-bottom: 100%;
      }
    }

    .wrapper-link {
      color: #37474f;
      text-decoration: none;
    }
    .card-block {
      padding: 20px;

      .card-title {
        margin-bottom: 10px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .sub-title {
        color: #5a5a5a;
      }

      .card-text {
        color: #76838f;
        margin-bottom: 9px;

        strong {
          color: #5a5a5a;
        }
      }
      ul {
        margin-left: 20px;
      }
    }
  }

  .card-small {
    .card-block {
      .card-title {
        font-size: 20px;
      }
      .card-text {
        margin-bottom: 2px;
      }
    }

  }

  .react-datepicker {
    display: flex !important;
  }

  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker-wrapper input {
    background-color: #f3f7f9;
    border: 1px solid #e4eaec;
    padding: 8px 17px;
    font-size: 14px;
    border-radius: 10px;
    color: #768390;
    width: 100%;
    margin-bottom: 10px;
    width: 100%;

    &::placeholder {
      color: #a7b3ba;
    }
  }

  .react-datepicker-wrapper input[disabled] {
    background-color: #dadada;
    cursor: not-allowed;
  }

  .react-datepicker__header {
    text-transform: capitalize;
  }

  .dropzone-image-wrapper {
    position: relative;
    min-height: 130px;
    margin-bottom: 20px;

    .dropzone-image-drop {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 30px;
      text-align: center;
      margin-bottom: 25px;
      position: relative;
      border-width: 2px;
      border-color: rgb(102, 102, 102);
      border-style: dashed;
      border-radius: 5px;
      cursor: pointer;
      position: absolute !important;
      top: 0;
      height: 100%;
      opacity: 0;
    }

    .dropzone-image-drop.dropzone-item-count-0 {
      opacity: 1;
    }

    .dropzone-image-drop.dropzone-item-count-0.dropzone-display-false {
      opacity: 0;
    }

    img {
      width: 100%;
    }
  }

  .sweet-alert {
    @media (max-width: 576px) {
      h2 {
        font-size: 25px;
      }
      li {
        font-size: 16px;
      }
    }
    ul {
      list-style: none;
    }
  }

  .ReactCrop {
    width: 100%;

    .ReactCrop__image {
      width: 100%;
      max-height: inherit;
    }

    .ReactCrop__drag-handle {
      width: 15px;
      height: 15px;
    }
  }
  .ReactCrop__result {
    width: 100%;
  }

  @media print {
    * {
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    body {
      font-size: 20px !important;
    }

    .main-header {
      /* background-repeat: no-repeat !important;
      background-position: center !important;
      background-color: #fff !important;
      background-image: url(${Logo}) !important;
      background-size: contain !important;
      height: 100px !important;

      img {
        display: none !important;
      } */

      display: none !important;
    }

    .page-title {
      text-align: center !important;
      margin: 0 !important;
      font-size: 36px !important;
    }

    .main-sidebar,
    .no-print {
      display: none !important;
    }

    .dashboard {
      margin: 0 !important;

      main {
        margin: 0 !important;
        max-width: 100% !important;
      }
    }

    .box {
      padding: 0;
      margin-top: 30px;
      border: 15px solid #fff;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/styles/global.js